import { makeAutoObservable } from "mobx";

class System {
  // 呼叫音频相关
  callAudio: HTMLAudioElement | null = null;
  hangupAudio: HTMLAudioElement | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  playCallAudio = () => {
    if (!this.callAudio) {
      this.callAudio = new window.Audio(require("@/assets/sounds/call.mp3"));
      this.callAudio.loop = true;
    }
    this.callAudio.currentTime = 0;
    this.callAudio.play();
  };

  stopCallAudio = () => {
    if (this.callAudio) {
      setTimeout(() => {
        this.callAudio!.pause();
        this.callAudio!.currentTime = 0;
      }, 1000); // 延时1秒，确保音频播放完毕
    }
  };

  playHangupAudio = () => {
    if (!this.hangupAudio) {
      this.hangupAudio = new window.Audio(require("@/assets/sounds/hang-up.mp3"));
    }
    this.hangupAudio.currentTime = 0;
    this.hangupAudio.play();
  };
}

const system = new System();
export default system;
